import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-154d9ca9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs tw-bg-[#ffffff] tw-max-w-[680px] tw-full-w" }
const _hoisted_2 = { class: "tab-header tw-flex tw-flex-wrap tw-px-[20px] sm:tw-px-[40px] tw-border-b-[#EFF0F1] tw-border-solid tw-border-[0] tw-border-b-[1px]" }
const _hoisted_3 = ["onClick"]

import { ref } from "vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'switchTabs',
  props: {
  /** Tabs Switch */
  tabs: {
    type: Array as () => ISwitchTabs[],
    required: true,
  },

  defaultTab: {
    type: Number,
    default: 0,
    required: false,
  },
},
  emits: ["update:tab"],
  setup(__props, { emit }) {

const props = __props;




const selectedTab = ref(props.defaultTab);

const selectTab = (tab: ISwitchTabs, index) => {
  emit("update:tab", tab.id);
  selectedTab.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["tab tw-font-Poppins tw-text-[12px] tw-leading-[130%] tw-font-[500] tw-py-[20px] tw-cursor-pointer tw-text-center", {
          selectedTab: selectedTab.value === index,
          unselectedTab: selectedTab.value !== index,
        }]),
          onClick: ($event: any) => (selectTab(tab, index))
        }, [
          _createElementVNode("span", null, _toDisplayString(tab.title), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})